document.addEventListener("DOMContentLoaded", function () {
  const productGridSelector = ".Collection_product_grid_inner_new";

  function scrollToProductGridWhenReady() {
    const grid = document.querySelector(productGridSelector) || document.getElementById("ProductGridContainer");
    if (!grid) return;

    // Wait for grid to be visibly rendered
    let attempts = 0;
    const maxAttempts = 10;
    const checkRendered = setInterval(() => {
      const rect = grid.getBoundingClientRect();
      if ((grid.offsetHeight > 0 && rect.top !== 0) || attempts >= maxAttempts) {
        clearInterval(checkRendered);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const stickyHeader = document.querySelector('.shopify-section-header-sticky') || document.querySelector('header');
        const headerOffset = stickyHeader ? stickyHeader.offsetHeight + 40 : 160;
        const offsetTop = Math.max(0, rect.top + scrollTop - headerOffset);

        window.scrollTo({ top: offsetTop, behavior: "smooth" });
      }
      attempts++;
    }, 100);
  }

  let activeGridObserver = null;
  function observeGridUpdateAndScroll() {
    const gridWrapper = document.querySelector(productGridSelector) || document.getElementById("ProductGridContainer");
    if (!gridWrapper) return;

    if (activeGridObserver) {
      activeGridObserver.disconnect();
    }

    activeGridObserver = new MutationObserver((mutations, obs) => {
      if (gridWrapper.innerHTML.trim().length > 0) {
        scrollToProductGridWhenReady();
        obs.disconnect();
        activeGridObserver = null;
      }
    });

    activeGridObserver.observe(gridWrapper, { childList: true, subtree: true });
  }

  // Expose helpers globally so facets.js can also invoke them
  window.scrollToProductGrid = scrollToProductGridWhenReady;
  window.observeGridUpdateAndScroll = observeGridUpdateAndScroll;

  // Listen for changes on desktop facet form, mobile drawer form, and in-grid custom filter forms
  document.addEventListener("change", function (e) {
    const target = e.target;
    if (
      target.closest("#FacetFiltersForm") ||
      target.closest("#FacetFiltersFormMobile") ||
      target.closest(".color-swatch-wrapper") ||
      target.closest("[js-custom-filter-form]")
    ) {
      observeGridUpdateAndScroll();
    }
  });

  document.body.addEventListener("click", function (e) {
    const target = e.target;
    if (target.closest("facet-remove") || target.classList.contains("icon-close-small")) {
      observeGridUpdateAndScroll();
    }
  });
});